import { render } from "./ProductCard.vue?vue&type=template&id=c2560c44&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=c2560c44&lang=scss&scoped=true"
import "./ProductCard.vue?vue&type=style&index=1&id=c2560c44&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2560c44"]])

export default __exports__